import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getFarmDetail, addFarm } from '../../../actions/farmsActions'
import { getOrigens } from '../../../actions/origensActions'
import FormFarm from '../../admin/farms/FormFarm'
import Swal from 'sweetalert2'

export default function FarmInsert() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {farm} = useSelector(state=>state.farms)
    const {origens} = useSelector(state=>state.origens)
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {name, origen, latitude, longitude} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleAdd = async(e) => {
        e.preventDefault()

        dispatch(addFarm(name, origen, latitude, longitude))
        setFormState({
            name: '',
            origen: '',
            latitude: '',
            longitude: ''
        })
        
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('farms.add')
        })
    }

    useEffect(()=>{
        dispatch(getFarmDetail(id))
        dispatch(getOrigens())
    }, [dispatch,id])

    useEffect(() => {
        if (farm) {
            setFormState({
                name: '',
                origen: '',
                latitude: '',
                longitude: ''
            })
        }
    }, [farm, dispatch, id])
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/farms`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('farms.volver')}
                    </Button>
                </Row>
                <h1>{t('farms.add')}</h1>
                <FormFarm submit={handleAdd} isNew={true} inputChange={handleInputChange} state={formState} origens={origens}></FormFarm>
            </Row>
        </Container>
    )
}
